import React, { useContext, createContext } from 'react';
import { useQuery } from 'urql';
import gql from 'graphql-tag';
import { useSupportContext } from '../../../helpers/context-provider';
import { isObjectEmpty } from '../../../utils/is-object-empty';

const TopicContext = createContext();

// data that is passed in comes from gatsby graphql
// we'll use that as offline/default data
// if logged in, we then we make a call to api, and get ordered data
export const TopicProvider = ({ children, data }) => {
  const supportContext = useSupportContext() || {};
  const { isLoading } = supportContext;

  // this usually comes from useStaticQuery
  // We're already getting it from template building, so no need to get it again
  const { strapiTopic, allStrapiTopic, allStrapiArticle, supportcenter = {} } = data || {};

  const [
    { fetching: topicQueryFetching, data: topicQueryData = {}, error: topicQueryError }
  ] = useQuery({
    query: gql`
      query TopicQuery($id: ID!) {
        getSupportData(input: { topicId: $id }) {
          videos
          topics
          groupedArticles {
            subTopicName
            subTopicId
            subTopicOrder
            articles
          }
        }
      }
    `,
    variables: { id: strapiTopic?.uid }
  });

  return (
    <TopicContext.Provider
      value={{
        ...supportContext,
        strapiTopic,
        allStrapiTopic,
        allStrapiArticle,
        ...(!isObjectEmpty(topicQueryData) ? topicQueryData : supportcenter),
        isLoading: isLoading || topicQueryFetching
      }}
    >
      {children}
    </TopicContext.Provider>
  );
};

export const useTopicContext = () => {
  const context = useContext(TopicContext);
  if (!context || context === undefined)
    throw new Error('useTopicContext must be used within a TopicProvider');

  return context;
};
